module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Company",
      "disabled": true,
      "placeholder": "Material dashboard"
    },
    model: {
      value: (_vm.user.company),
      callback: function($$v) {
        _vm.user.company = $$v
      },
      expression: "user.company"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Username",
      "placeholder": "Username"
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.user.username = $$v
      },
      expression: "user.username"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "email",
      "label": "Email",
      "placeholder": "Email"
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.user.email = $$v
      },
      expression: "user.email"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "First Name",
      "placeholder": "First Name"
    },
    model: {
      value: (_vm.user.firstName),
      callback: function($$v) {
        _vm.user.firstName = $$v
      },
      expression: "user.firstName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Last Name",
      "placeholder": "Last Name"
    },
    model: {
      value: (_vm.user.lastName),
      callback: function($$v) {
        _vm.user.lastName = $$v
      },
      expression: "user.lastName"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Address",
      "placeholder": "Address"
    },
    model: {
      value: (_vm.user.address),
      callback: function($$v) {
        _vm.user.address = $$v
      },
      expression: "user.address"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "City",
      "placeholder": "City"
    },
    model: {
      value: (_vm.user.city),
      callback: function($$v) {
        _vm.user.city = $$v
      },
      expression: "user.city"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Country",
      "placeholder": "Country"
    },
    model: {
      value: (_vm.user.country),
      callback: function($$v) {
        _vm.user.country = $$v
      },
      expression: "user.country"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "number",
      "label": "Postal Code",
      "placeholder": "Postal Code"
    },
    model: {
      value: (_vm.user.postalCode),
      callback: function($$v) {
        _vm.user.postalCode = $$v
      },
      expression: "user.postalCode"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" Lamborghini Mercy, Your chick she so thirsty, I'm in that two seat Lambo.")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.aboutMe),
      expression: "user.aboutMe"
    }],
    staticClass: "form-control border-input",
    attrs: {
      "rows": "5",
      "placeholder": "Here can be your description"
    },
    domProps: {
      "value": (_vm.user.aboutMe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.aboutMe = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateProfile($event)
      }
    }
  }, [_vm._v("Update Profile")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "purple"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Edit Profile")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("Complete your profile")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e6166178!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/UserProfile/EditProfileForm.vue
// module id = 176
// module chunks = 2